import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';

const UrgencySection = () => {
  return (
    <Box sx={{ textAlign: 'center', py: { xs: 3, xxl: 6 }, px: 2, backgroundColor: '#fff' }}>
        <Box
            sx={{
                width: { xs: "100%", xxl: "70%" },
                margin: "0 auto"
            }}
        >
      
            {/* Countdown Section */}
            <Box
                sx={{
                border: '2px solid #20defa',
                borderRadius: '16px',
                py: 4,
                px: 2,
                mb: { xs: 0, xxl: 0 },
                backgroundColor: '#e5e5e5'
                }}
            >
                <Typography 
                    variant="subtitle1"
                    sx={{ 
                        fontWeight: 500, 
                        fontSize: { xs: "14px", xxl: "21px" },  
                    }}>
                    Lorem ipsum viverra
                </Typography>

                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: "20px", xxl: "36px" },
                        color: '#002077',
                        mt: 1,
                        mb: 4,
                        textTransform: 'uppercase'
                    }}
                >
                    Lorem ipsum dolor sit amet, consectev!
                </Typography>

                {/* Countdown Timer */}
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                {[
                    { value: '18', label: 'HOURS' },
                    { value: '03', label: 'MINUTES' },
                    { value: '14', label: 'SECONDS' },
                ].map((item, idx) => (
                    <Box key={idx}>
                    <Typography
                        sx={{
                        backgroundColor: '#20defa',
                        borderRadius: '12px',
                        fontWeight: 700,
                        fontSize: '32px',
                        px: 2.5,
                        py: 1,
                        color: '#fff'
                        }}
                    >
                        {item.value}
                    </Typography>
                    <Typography sx={{ fontSize: { xs: "12px", xxl: "16px" }, color: '#000', mt: 0.5 }}>
                        {item.label}
                    </Typography>
                    </Box>
                ))}
                </Box>

                <Button
                    variant="contained"
                    sx={{
                        mt: 4,
                        backgroundColor: '#002077',
                        color: '#fff',
                        fontWeight: "700", 
                        fontSize: { xs: "16px", sm: "18px", md: "20px" }, 
                        lineHeight: "14px",
                        letterSpacing: "normal",
                        borderRadius: '16px',
                        px: { xs: 2, sm: 4 },
                        py: { xs: 0, sm: 2 },
                        textTransform: 'none',
                        "&:hover": {
                            backgroundColor: "#20defa",
                            color: "#fff",
                        },
                    }}
                >
                    Secure seat now!
                </Button>
            </Box>

            {/* Icon Feature Grid */}
            {/* <Typography
                variant="h2"
                sx={{
                    fontWeight: 'bold',
                    fontSize: { xs: "20px", xxl: "36px" },
                    color: '#002077',
                    mt: 1,
                    mb: { xs: 2, xxl: 4 },
                    textTransform: 'uppercase'
                }}
            >
                Lorem ipsum dolor sit amet.
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', gap: { xs: 2, xxl: 4.3 }, flexWrap: 'wrap', mb: { xs: 3, xxl: 6 } }}>
                {[...Array(4)].map((_, idx) => (
                <Box
                    key={idx}
                    sx={{
                        border: '1px solid #000',
                        borderRadius: '8px',
                        p: 3,
                        textAlign: 'center',
                        width: { xs: '100%', xxl: '23%' },
                        height: "100%",
                        fontSize: { xs: "36px", xxl: "48px" }
                    }}
                >
                    <ThumbUpAltIcon sx={{ color: '#20defa' }} />
                    <Typography sx={{ color: '#002077', fontWeight: 600, fontSize: { xs: "14px", xxl: "21px" } }}>
                        Lorem ipsum dolor sit
                    </Typography>
                </Box>
                ))}
            </Box> */}

            {/* <Button
                variant="contained"
                sx={{
                backgroundColor: '#002077',
                color: '#fff',
                fontWeight: "700", 
                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                lineHeight: "14px",
                letterSpacing: "normal",
                borderRadius: '16px',
                px: { xs: 2, sm: 4 },
                py: { xs: 0, sm: 2 },
                textTransform: 'none',
                "&:hover": {
                    backgroundColor: "#20defa",
                    color: "#fff",
                },
                }}
            >
                Let’s talk growth
            </Button> */}
        </Box>
    </Box>
  );
};

export default UrgencySection;